import React, { useState } from "react";
import moment from "moment";
import eye from "../../assets/view-eye.svg";
import "../../modules/customers/customers.css";
import ImageViewModal from "../modals/ImageViewModal";
import PdfView from "../modals/PdfView";
import { pdfChecker } from "../utilites/helper";

const DoctorView = ({ customerDetail }) => {
  const [imageModal, setImageModal] = useState(false);
  const [imageTitleData, setImageTitleData] = useState("");
  const [imageUrlData, setImageUrlData] = useState("");
  const [openPdf, setOpenPdf] = useState(false);
  const [pdfFileUrl, setPdfFileUrl] = useState(null);
  const [filename, setFileName] = useState(null);

  const doctorBasicDetails = [
    {
      heading: "Jivini’s Doctor Code",
      title: customerDetail?.code ? customerDetail?.code : "--",
    },
    {
      heading: "Doctor Name",
      title: customerDetail?.name
        ? `DR. ${customerDetail?.name.toUpperCase()}`
        : "--",
    },

    {
      heading: "Pharmacy Type",
      title:
        customerDetail?.doctorSubscribedVendors.length > 0
          ? customerDetail?.doctorSubscribedVendors[0].onboarding_type
          : "--",
    },
    {
      heading: "Order Authority",
      title:
        customerDetail?.pharmacy_type === "attach"
          ? customerDetail?.doctorAttachPharmacy?.order_authority ===
            "allow_pharmacy"
            ? customerDetail?.doctorAttachPharmacy?.pharmacy?.pharmacy_name
            : customerDetail?.name
          : "--",
    },
    {
      heading: "Qualification",
      title: customerDetail?.qualification
        ? customerDetail?.qualification
        : "--",
    },

    {
      heading: "Specialization",
      title: customerDetail?.specialization?.name
        ? customerDetail?.specialization?.name
        : "--",
    },
    {
      heading: "MCI Number",
      title: customerDetail?.medical_council_registration_number
        ? customerDetail?.medical_council_registration_number
        : "--",
    },

    {
      heading: "Onboarded By",
      title: customerDetail?.onboardingFieldforce?.fieldForceUser?.name
        ? customerDetail?.onboardingFieldforce?.fieldForceUser?.name
        : "--",
    },
    {
      heading: "Onboarded Date & Time",
      title: customerDetail?.createdAt
        ? moment(customerDetail?.createdAt).format("DD MMM YYYY, HH:mm A")
        : "--",
    },
    {
      heading: "Linked Headquarters",
      title: Array.from(
        new Set(
          customerDetail?.doctorHeadQuaters?.map((ele) => ele?.headQuater?.id)
        )
      ).map((uniqueHQId, index) => {
        const uniqueHQ = customerDetail?.doctorHeadQuaters?.find(
          (ele) => ele?.headQuater?.id === uniqueHQId
        )?.headQuater?.name;
        return (
          <span key={index}>
            {index ? <span className="mx-1 color_b0b3c7">|</span> : ""}
            {uniqueHQ}
          </span>
        );
      }),
    },
  ];

  const doctorContactDetails = [
    {
      heading: "Mobile Number",
      title: `+91 ${customerDetail?.mobile}`
        ? `+91 ${customerDetail?.mobile}`
        : "--",
    },
    {
      heading: "Alternate Mobile Number",
      title: `+91 ${customerDetail?.alternate_mobile}`
        ? `+91 ${customerDetail?.alternate_mobile}`
        : "--",
    },
    {
      heading: "Email Address",
      title: customerDetail?.email ? customerDetail?.email : "--",
    },
    {
      heading: "Address",
      title:
        customerDetail?.address &&
        `${customerDetail?.address?.address_one}, ${customerDetail?.address?.address_two}, ${customerDetail?.address?.address_three}`,
    },
    {
      heading: "Landmark",
      title: customerDetail?.address?.landmark
        ? customerDetail?.address?.landmark
        : "--",
    },
    {
      heading: "State",
      title: customerDetail?.state?.name ? customerDetail?.state?.name : "--",
    },
    {
      heading: "District",
      title: customerDetail?.district?.name
        ? customerDetail?.district?.name
        : "--",
    },
    {
      heading: "City",
      title: customerDetail?.city?.name ? customerDetail?.city?.name : "--",
    },
    {
      heading: "Pincode",
      title: customerDetail?.pincode ? customerDetail?.pincode : "--",
    },
  ];

  const PharmacyBasicDetails = [
    {
      heading: "Jivini’s Pharmacy Code",
      title: customerDetail?.vendorDoctorPharmacy?.pharmacy?.code
        ? customerDetail?.vendorDoctorPharmacy?.pharmacy?.code
        : "--",
    },
    {
      heading: "Pharmacy Name",
      title: customerDetail?.vendorDoctorPharmacy?.pharmacy?.pharmacy_name
        ? customerDetail?.vendorDoctorPharmacy?.pharmacy?.pharmacy_name
        : "--",
    },
    {
      heading: "Drug License Number - 20A",
      title: customerDetail?.vendorDoctorPharmacy?.pharmacy
        ?.drug_licence_number_20_a
        ? customerDetail?.vendorDoctorPharmacy?.pharmacy
            ?.drug_licence_number_20_a
        : "--",
    },
    {
      heading: "Drug License Number - 20B",
      title: customerDetail?.vendorDoctorPharmacy?.pharmacy
        ?.drug_licence_number_20_b
        ? customerDetail?.vendorDoctorPharmacy?.pharmacy
            ?.drug_licence_number_20_b
        : "--",
    },
    {
      heading: "GST Number",
      title: customerDetail?.vendorDoctorPharmacy?.pharmacy?.gst_number
        ? customerDetail?.vendorDoctorPharmacy?.pharmacy?.gst_number
        : "--",
    },
    {
      heading: "Onboarded By",
      title: customerDetail?.onboardingFieldforce?.fieldForceUser?.name
        ? customerDetail?.onboardingFieldforce?.fieldForceUser?.name
        : "--",
    },
    {
      heading: "Onboarded Date & Time",
      title: customerDetail?.vendorDoctorPharmacy?.pharmacy?.createdAt
        ? moment(
            customerDetail?.vendorDoctorPharmacy?.pharmacy?.createdAt
          ).format("DD MMM YYYY, HH:mm A")
        : "--",
    },
  ];

  const pharmacyContactDetails = [
    {
      heading: "Mobile Number",
      title: `+91 ${customerDetail?.vendorDoctorPharmacy?.pharmacy?.mobile}`,
    },
    {
      heading: "Alternate Mobile Number",
      title: customerDetail?.vendorDoctorPharmacy?.pharmacy?.alternate_mobile
        ? `+91 ${customerDetail?.vendorDoctorPharmacy?.pharmacy?.alternate_mobile}`
        : "--",
    },
    {
      heading: "Email Address",
      title: customerDetail?.vendorDoctorPharmacy?.pharmacy?.email
        ? customerDetail?.vendorDoctorPharmacy?.pharmacy?.email
        : "--",
    },
    {
      heading: "Address",
      title:
        customerDetail?.address &&
        `${
          customerDetail?.vendorDoctorPharmacy?.pharmacy?.address?.address_one
        }, ${
          customerDetail?.vendorDoctorPharmacy?.pharmacy?.address?.address_two
        }, ${
          customerDetail?.vendorDoctorPharmacy?.pharmacy?.address
            ?.address_three ?? ""
        }`,
    },
    {
      heading: "Landmark",
      title:
        customerDetail?.vendorDoctorPharmacy?.pharmacy?.address?.landmark ??
        "--",
    },
    {
      heading: "State",
      title: customerDetail?.vendorDoctorPharmacy?.pharmacy?.state?.name
        ? customerDetail?.vendorDoctorPharmacy?.pharmacy?.state?.name
        : "--",
    },
    {
      heading: "District",
      title: customerDetail?.vendorDoctorPharmacy?.pharmacy?.district?.name
        ? customerDetail?.vendorDoctorPharmacy?.pharmacy?.district?.name
        : "--",
    },
    {
      heading: "City",
      title: customerDetail?.vendorDoctorPharmacy?.pharmacy?.city?.name
        ? customerDetail?.vendorDoctorPharmacy?.pharmacy?.city?.name
        : "--",
    },
    {
      heading: "Pincode",
      title: customerDetail?.vendorDoctorPharmacy?.pharmacy?.pincode
        ? customerDetail?.vendorDoctorPharmacy?.pharmacy?.pincode
        : "--",
    },
  ];

  return (
    <>
      {/* DOCTOR BASIC DETAILS */}
      {customerDetail?.is_basic_details == true && (
        <div className="mb-4">
          <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
            Doctor's Basic Details
          </div>
          <div className="product-details-container ms-2 ps-1">
            <div className="pt-3 row ">
              {doctorBasicDetails.map((item, index) => (
                <div className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-1 me-4 px-2 customers-basic-heading-container">
                  <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                    {item.heading}
                  </h5>
                  <p
                    className={`fs_15 fn_Nunito fw_500 color_262c3d text-capitalize`}
                  >
                    {item.title}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* DOCTOR CONTACT DETAILS */}
      {customerDetail?.is_contact_details === true && (
        <div className="mb-4">
          <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
            Doctor's Contact Details
          </div>
          <div className="product-details-container ms-2 ps-1">
            <div className="pt-3 row row-cols-6">
              {doctorContactDetails.map((item, index) => (
                <div className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-2 mx-0 pe-3 customers-heading-container">
                  <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                    {item.heading}
                  </h5>
                  {item.heading === "Email Address" ? (
                    <p
                      className={`fs_15 fn_Nunito fw_500 color_262c3d text-truncate col-lg-10 email-slice `}
                      title={item.title}
                    >
                      {item.title}
                    </p>
                  ) : item.heading ? (
                    <p className="fs_15 fn_Nunito fw_500 color_262c3d">
                      {item.title}
                    </p>
                  ) : (
                    <p
                      className={`fs_15 fn_Nunito fw_500 color_262c3d  text-nowrap`}
                    >
                      {item.title}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <>
        {customerDetail?.is_mci_certificate && (
          <div className="basic-details-container my-3 mt-4  my-auto d-flex align-items-center ">
            <label className="basic-title mx-2 mb-1">Documents</label>
          </div>
        )}
        <div className="row">
          {customerDetail?.is_mci_certificate && (
            <div className="col-xxl-4 col-6">
              <div className="mx-0 px-3">
                <div className="my-2">
                  <div className="upload-image-label-container d-flex justify-content-between">
                    <label className="my-1 Neutral_Color">
                      MCI Certificate
                    </label>
                  </div>

                  <div
                    className="manufacturer-doc-upload-container"
                    style={{ position: "relative" }}
                  >
                    {pdfChecker(customerDetail?.mci_certificate) ? (
                      <div className="manufacturer-doc-upload-container">
                        <iframe
                          src={`${customerDetail?.mci_certificate}#toolbar=0`}
                          className="pdf-view-doc"
                        />
                      </div>
                    ) : (
                      <div
                        className="manufacturer-doc-upload-container"
                        style={{ position: "relative" }}
                      >
                        <img
                          className="image-upload"
                          src={customerDetail?.mci_certificate}
                        />
                      </div>
                    )}

                    <div
                      className="w-100"
                      style={{
                        position: "absolute",
                        zIndex: "55",
                        top: "0",
                        maxWidth: "450px",
                      }}
                    >
                      <div
                        className="manufacturer-doc-upload-container"
                        style={{
                          backgroundColor: "rgb(38, 44, 61, 0.6 )",
                        }}
                      >
                        <div
                          className="align-items-center"
                          style={{
                            position: "absolute",
                            zIndex: "55",
                            top: "43%",
                            left: "40%",
                          }}
                        >
                          <img src={eye} className="mb-2" />
                          {pdfChecker(
                            customerDetail?.doctorAttachPharmacy?.pharmacy
                              ?.drug_licence_certificate_20_a
                          ) ? (
                            <button
                              className="fs_16 fw_600"
                              style={{
                                backgroundColor: "transparent",
                                color: "#E7E5FF",
                                border: "none",
                              }}
                              onClick={() => {
                                setOpenPdf(true);
                                setPdfFileUrl(customerDetail?.mci_certificate);
                                setFileName("MCI Certificate");
                              }}
                            >
                              VIEW
                            </button>
                          ) : (
                            <button
                              className="fs_16 fw_600"
                              style={{
                                backgroundColor: "transparent",
                                color: "#E7E5FF",
                                border: "none",
                              }}
                              onClick={() => {
                                setImageModal(true);
                                setImageUrlData(
                                  customerDetail?.mci_certificate
                                );
                                setFileName("MCI Certificate");
                              }}
                            >
                              VIEW
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {customerDetail?.doctorAttachPharmacy != null &&
            customerDetail?.pharmacy_type != "dispensing" && (
              <>
                <div className="col-xxl-4 col-6">
                  <div className="mx-0 px-3">
                    <div className="my-2">
                      <div className="upload-image-label-container d-flex justify-content-between">
                        <label className="my-1 Neutral_Color">
                          Drug License Certificate - 20A
                        </label>
                      </div>

                      <div
                        className={` h-100`}
                        style={{
                          height: "25rem",
                          overflowY: "auto",
                          overflowX: "hidden",
                          scrollBehavior: "smooth",
                          position: "relative",
                        }}
                      >
                        {pdfChecker(
                          customerDetail?.doctorAttachPharmacy?.pharmacy
                            ?.drug_licence_certificate_20_a
                        ) ? (
                          <div className="manufacturer-doc-upload-container">
                            <iframe
                              src={`${customerDetail?.doctorAttachPharmacy?.pharmacy?.drug_licence_certificate_20_a}#toolbar=0`}
                              className="pdf-view-doc"
                            />
                          </div>
                        ) : (
                          <div
                            className="manufacturer-doc-upload-container"
                            style={{ position: "relative" }}
                          >
                            <img
                              className="image-upload"
                              src={
                                customerDetail?.doctorAttachPharmacy?.pharmacy
                                  ?.drug_licence_certificate_20_a
                              }
                            />
                          </div>
                        )}
                        <div
                          className="w-100"
                          style={{
                            position: "absolute",
                            zIndex: "55",
                            top: "0",
                            maxWidth: "450px",
                          }}
                        >
                          <div
                            className="manufacturer-doc-upload-container"
                            style={{ backgroundColor: "rgb(38, 44, 61, 0.5)" }}
                          >
                            <div
                              className="align-items-center"
                              style={{
                                position: "absolute",
                                zIndex: "55",
                                top: "43%",
                                left: "40%",
                              }}
                            >
                              <img src={eye} className="mb-2" />
                              {pdfChecker(
                                customerDetail?.doctorAttachPharmacy?.pharmacy
                                  ?.drug_licence_certificate_20_a
                              ) ? (
                                <button
                                  className="fs_16 fw_600"
                                  style={{
                                    backgroundColor: "transparent",
                                    color: "#E7E5FF",
                                    border: "none",
                                  }}
                                  onClick={() => {
                                    setOpenPdf(true);
                                    setPdfFileUrl(
                                      customerDetail?.doctorAttachPharmacy
                                        ?.pharmacy
                                        ?.drug_licence_certificate_20_a
                                    );
                                    setFileName("Drug Licence Certificate 20A");
                                  }}
                                >
                                  VIEW
                                </button>
                              ) : (
                                <button
                                  className="fs_16 fw_600"
                                  style={{
                                    backgroundColor: "transparent",
                                    color: "#E7E5FF",
                                    border: "none",
                                  }}
                                  onClick={() => {
                                    setImageModal(true);
                                    setImageUrlData(
                                      customerDetail?.doctorAttachPharmacy
                                        ?.pharmacy
                                        ?.drug_licence_certificate_20_a
                                    );
                                    setFileName("Drug Licence Certificate 20A");
                                  }}
                                >
                                  VIEW
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-4 col-6">
                  <div className="mx-0 px-3">
                    <div className="my-2">
                      <div className="upload-image-label-container d-flex justify-content-between">
                        <label className="my-1 Neutral_Color">
                          Drug License Certificate - 20B
                        </label>
                      </div>
                      <div
                        className={` h-100`}
                        style={{
                          height: "25rem",
                          overflowY: "auto",
                          overflowX: "hidden",
                          scrollBehavior: "smooth",
                          position: "relative",
                        }}
                      >
                        {pdfChecker(
                          customerDetail?.doctorAttachPharmacy?.pharmacy
                            ?.drug_licence_certificate_20_b
                        ) ? (
                          <div className="manufacturer-doc-upload-container">
                            <iframe
                              src={`${customerDetail?.doctorAttachPharmacy?.pharmacy?.drug_licence_certificate_20_b}#toolbar=0`}
                              className="pdf-view-doc"
                            />
                          </div>
                        ) : (
                          <div
                            className="manufacturer-doc-upload-container"
                            style={{ position: "relative" }}
                          >
                            <img
                              className="image-upload"
                              src={
                                customerDetail?.doctorAttachPharmacy?.pharmacy
                                  ?.drug_licence_certificate_20_b
                              }
                            />
                          </div>
                        )}
                        <div
                          className="w-100"
                          style={{
                            position: "absolute",
                            zIndex: "55",
                            top: "0",
                            maxWidth: "450px",
                          }}
                        >
                          <div
                            className="manufacturer-doc-upload-container"
                            style={{ backgroundColor: "rgb(38, 44, 61, 0.5)" }}
                          >
                            <div
                              className="align-items-center"
                              style={{
                                position: "absolute",
                                zIndex: "55",
                                top: "43%",
                                left: "40%",
                              }}
                            >
                              <img src={eye} className="mb-2" />
                              {pdfChecker(
                                customerDetail?.doctorAttachPharmacy?.pharmacy
                                  ?.drug_licence_certificate_20_b
                              ) ? (
                                <button
                                  className="fs_16 fw_600"
                                  style={{
                                    backgroundColor: "transparent",
                                    color: "#E7E5FF",
                                    border: "none",
                                  }}
                                  onClick={() => {
                                    setOpenPdf(true);
                                    setPdfFileUrl(
                                      customerDetail?.doctorAttachPharmacy
                                        ?.pharmacy
                                        ?.drug_licence_certificate_20_b
                                    );
                                    setFileName("Drug Licence Certificate 20B");
                                  }}
                                >
                                  VIEW
                                </button>
                              ) : (
                                <button
                                  className="fs_16 fw_600"
                                  style={{
                                    backgroundColor: "transparent",
                                    color: "#E7E5FF",
                                    border: "none",
                                  }}
                                  onClick={() => {
                                    setImageModal(true);
                                    setImageUrlData(
                                      customerDetail?.doctorAttachPharmacy
                                        ?.pharmacy
                                        ?.drug_licence_certificate_20_b
                                    );
                                    setFileName("Drug Licence Certificate 20B");
                                  }}
                                >
                                  VIEW
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-4 col-6">
                  <div className="mx-0 px-3">
                    <div className="my-2">
                      <div className="upload-image-label-container d-flex justify-content-between">
                        <label className="my-1 Neutral_Color">
                          GST Certificate
                        </label>
                      </div>
                      <div
                        className={` h-100`}
                        style={{
                          height: "25rem",
                          overflowY: "auto",
                          overflowX: "hidden",
                          scrollBehavior: "smooth",
                          position: "relative",
                        }}
                      >
                        {pdfChecker(
                          customerDetail?.doctorAttachPharmacy?.pharmacy
                            ?.gst_certificate
                        ) ? (
                          <div className="manufacturer-doc-upload-container">
                            <iframe
                              src={`${customerDetail?.doctorAttachPharmacy?.pharmacy?.gst_certificate}#toolbar=0`}
                              className="pdf-view-doc"
                            />
                          </div>
                        ) : (
                          <div
                            className="manufacturer-doc-upload-container"
                            style={{ position: "relative" }}
                          >
                            <img
                              className="image-upload"
                              src={
                                customerDetail?.doctorAttachPharmacy?.pharmacy
                                  ?.gst_certificate
                              }
                            />
                          </div>
                        )}
                        <div
                          className="w-100"
                          style={{
                            position: "absolute",
                            zIndex: "55",
                            top: "0",
                            maxWidth: "450px",
                          }}
                        >
                          <div
                            className="manufacturer-doc-upload-container"
                            style={{ backgroundColor: "rgb(38, 44, 61, 0.5)" }}
                          >
                            <div
                              className="align-items-center"
                              style={{
                                position: "absolute",
                                zIndex: "55",
                                top: "43%",
                                left: "40%",
                              }}
                            >
                              <img src={eye} className="mb-2" />
                              {pdfChecker(
                                customerDetail?.doctorAttachPharmacy?.pharmacy
                                  ?.gst_certificate
                              ) ? (
                                <button
                                  className="fs_16 fw_600"
                                  style={{
                                    backgroundColor: "transparent",
                                    color: "#E7E5FF",
                                    border: "none",
                                  }}
                                  onClick={() => {
                                    setOpenPdf(true);
                                    setPdfFileUrl(
                                      customerDetail?.doctorAttachPharmacy
                                        ?.pharmacy?.gst_certificate
                                    );
                                    setFileName("GST Certificate");
                                  }}
                                >
                                  VIEW
                                </button>
                              ) : (
                                <button
                                  className="fs_16 fw_600"
                                  style={{
                                    backgroundColor: "transparent",
                                    color: "#E7E5FF",
                                    border: "none",
                                  }}
                                  onClick={() => {
                                    setImageModal(true);
                                    setImageUrlData(
                                      customerDetail?.doctorAttachPharmacy
                                        ?.pharmacy?.gst_certificate
                                    );
                                    setFileName("GST Certificate");
                                  }}
                                >
                                  VIEW
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          {customerDetail?.doctorSelfPharmacy != null && (
            <>
              <div className="col-xxl-4 col-6">
                <div className="mx-4 px-3">
                  <div className="my-2">
                    <div className="upload-image-label-container d-flex justify-content-between">
                      <label className="my-1 Neutral_Color">
                        Drug License Certificate - 20A
                      </label>
                    </div>

                    <div
                      className={` h-100`}
                      style={{
                        height: "25rem",
                        overflowY: "auto",
                        overflowX: "hidden",
                        scrollBehavior: "smooth",
                        position: "relative",
                      }}
                    >
                      {pdfChecker(
                        customerDetail?.doctorSelfPharmacy
                          ?.drug_licence_certificate_20_a
                      ) ? (
                        <div className="manufacturer-doc-upload-container">
                          <iframe
                            src={`${customerDetail?.doctorSelfPharmacy?.drug_licence_certificate_20_a}#toolbar=0`}
                            className="pdf-view-doc"
                          />
                        </div>
                      ) : (
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{ position: "relative" }}
                        >
                          <img
                            className="image-upload"
                            src={
                              customerDetail?.doctorSelfPharmacy
                                ?.drug_licence_certificate_20_a
                            }
                          />
                        </div>
                      )}
                      <div
                        className="w-100"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          top: "0",
                          maxWidth: "450px",
                        }}
                      >
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{ backgroundColor: "rgb(38, 44, 61, 0.5)" }}
                        >
                          <div
                            className="align-items-center"
                            style={{
                              position: "absolute",
                              zIndex: "55",
                              top: "43%",
                              left: "40%",
                            }}
                          >
                            <img src={eye} className="mb-2" />
                            {pdfChecker(
                              customerDetail?.doctorSelfPharmacy
                                ?.drug_licence_certificate_20_a
                            ) ? (
                              <button
                                className="fs_16 fw_600"
                                style={{
                                  backgroundColor: "transparent",
                                  color: "#E7E5FF",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setOpenPdf(true);
                                  setPdfFileUrl(
                                    customerDetail?.doctorSelfPharmacy
                                      ?.drug_licence_certificate_20_a
                                  );
                                  setFileName("Drug Licence Certificate 20A");
                                }}
                              >
                                VIEW
                              </button>
                            ) : (
                              <button
                                className="fs_16 fw_600"
                                style={{
                                  backgroundColor: "transparent",
                                  color: "#E7E5FF",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setImageModal(true);
                                  setImageUrlData(
                                    customerDetail?.doctorSelfPharmacy
                                      ?.drug_licence_certificate_20_a
                                  );
                                  setFileName("Drug Licence Certificate 20A");
                                }}
                              >
                                VIEW
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-4 col-6">
                <div className="mx-4 px-3">
                  <div className="my-2">
                    <div className="upload-image-label-container d-flex justify-content-between">
                      <label className="my-1 Neutral_Color">
                        Drug License Certificate - 20B
                      </label>
                    </div>
                    <div
                      className={` h-100`}
                      style={{
                        height: "25rem",
                        overflowY: "auto",
                        overflowX: "hidden",
                        scrollBehavior: "smooth",
                        position: "relative",
                      }}
                    >
                      {pdfChecker(
                        customerDetail?.doctorSelfPharmacy
                          ?.drug_licence_certificate_20_b
                      ) ? (
                        <div className="manufacturer-doc-upload-container">
                          <iframe
                            src={`${customerDetail?.doctorSelfPharmacy?.drug_licence_certificate_20_b}#toolbar=0`}
                            className="pdf-view-doc"
                          />
                        </div>
                      ) : (
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{ position: "relative" }}
                        >
                          <img
                            className="image-upload"
                            src={
                              customerDetail?.doctorSelfPharmacy
                                ?.drug_licence_certificate_20_b
                            }
                          />
                        </div>
                      )}
                      <div
                        className="w-100"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          top: "0",
                          maxWidth: "450px",
                        }}
                      >
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{ backgroundColor: "rgb(38, 44, 61, 0.5)" }}
                        >
                          <div
                            className="align-items-center"
                            style={{
                              position: "absolute",
                              zIndex: "55",
                              top: "43%",
                              left: "40%",
                            }}
                          >
                            <img src={eye} className="mb-2" />
                            {pdfChecker(
                              customerDetail?.doctorSelfPharmacy
                                ?.drug_licence_certificate_20_b
                            ) ? (
                              <button
                                className="fs_16 fw_600"
                                style={{
                                  backgroundColor: "transparent",
                                  color: "#E7E5FF",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setOpenPdf(true);
                                  setPdfFileUrl(
                                    customerDetail?.doctorSelfPharmacy
                                      ?.drug_licence_certificate_20_b
                                  );
                                  setFileName("Drug Licence Certificate 20B");
                                }}
                              >
                                VIEW
                              </button>
                            ) : (
                              <button
                                className="fs_16 fw_600"
                                style={{
                                  backgroundColor: "transparent",
                                  color: "#E7E5FF",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setImageModal(true);
                                  setImageUrlData(
                                    customerDetail?.doctorSelfPharmacy
                                      ?.drug_licence_certificate_20_b
                                  );
                                  setFileName("Drug Licence Certificate 20B");
                                }}
                              >
                                VIEW
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-4 col-6">
                <div className="mx-4 px-3">
                  <div className="my-2">
                    <div className="upload-image-label-container d-flex justify-content-between">
                      <label className="my-1 Neutral_Color">
                        GST Certificate
                      </label>
                    </div>

                    <div
                      className={` h-100`}
                      style={{
                        height: "25rem",
                        overflowY: "auto",
                        overflowX: "hidden",
                        scrollBehavior: "smooth",
                        position: "relative",
                      }}
                    >
                      {pdfChecker(
                        customerDetail?.doctorSelfPharmacy?.gst_certificate
                      ) ? (
                        <div className="manufacturer-doc-upload-container">
                          <iframe
                            src={`${customerDetail?.doctorSelfPharmacy?.gst_certificate}#toolbar=0`}
                            className="pdf-view-doc"
                          />
                        </div>
                      ) : (
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{ position: "relative" }}
                        >
                          <img
                            className="image-upload"
                            src={
                              customerDetail?.doctorSelfPharmacy
                                ?.gst_certificate
                            }
                          />
                        </div>
                      )}
                      <div
                        className="w-100"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          top: "0",
                          maxWidth: "450px",
                        }}
                      >
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{ backgroundColor: "rgb(38, 44, 61, 0.5)" }}
                        >
                          <div
                            className="align-items-center"
                            style={{
                              position: "absolute",
                              zIndex: "55",
                              top: "43%",
                              left: "40%",
                            }}
                          >
                            <img src={eye} className="mb-2" />
                            {pdfChecker(
                              customerDetail?.doctorSelfPharmacy
                                ?.gst_certificate
                            ) ? (
                              <button
                                className="fs_16 fw_600"
                                style={{
                                  backgroundColor: "transparent",
                                  color: "#E7E5FF",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setOpenPdf(true);
                                  setPdfFileUrl(
                                    customerDetail?.doctorSelfPharmacy
                                      ?.gst_certificate
                                  );
                                  setFileName("GST Certificate");
                                }}
                              >
                                VIEW
                              </button>
                            ) : (
                              <button
                                className="fs_16 fw_600"
                                style={{
                                  backgroundColor: "transparent",
                                  color: "#E7E5FF",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setImageModal(true);
                                  setImageUrlData(
                                    customerDetail?.doctorSelfPharmacy
                                      ?.gst_certificate
                                  );
                                  setFileName("GST Certificate");
                                }}
                              >
                                VIEW
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </>

      <div>
        <div className="basic-details-container my-3 mt-4  my-auto d-flex align-items-center ">
          <label className="basic-title mx-2 mb-1">Onboarding Photos</label>
        </div>
        <div className="row my-2">
          <div className="col-xxl-4 col-6">
            <div className="mx-0 px-3">
              <div className="my-2">
                <div className="upload-image-label-container d-flex justify-content-between">
                  <label className="my-1 Neutral_Color fs_sm_14">
                    Clinic/Hospital
                  </label>
                </div>

                <div
                  className="manufacturer-doc-upload-container"
                  style={{ position: "relative" }}
                >
                  <img
                    className="image-upload"
                    src={customerDetail?.hospital_photo}
                  />
                  <div
                    className="w-100"
                    style={{
                      position: "absolute",
                      zIndex: "55",
                      top: "0",
                      maxWidth: "450px",
                    }}
                  >
                    <div
                      className="manufacturer-doc-upload-container"
                      style={{
                        backgroundColor: "rgb(38, 44, 61, 0.6 )",
                      }}
                    >
                      <div
                        className="align-items-center px-2 mx-2 my-2"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          backgroundColor: "#fff",
                          borderRadius: "5px",
                        }}
                      >
                        <span className="fs_11 Medium_Purple fw_500">
                          {customerDetail?.hospital_photo_lat} ,
                          <span className="ms-1">
                            {customerDetail?.hospital_photo_long}
                          </span>
                        </span>
                      </div>
                      <div
                        className="align-items-center"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          top: "43%",
                          left: "40%",
                        }}
                      >
                        <img src={eye} className="mb-2" />
                        <button
                          className="fs_16 fw_600"
                          style={{
                            backgroundColor: "transparent",
                            color: "#E7E5FF",
                            border: "none",
                          }}
                          onClick={() => {
                            setImageModal(true);
                            setImageTitleData("Clinic/Hospital");
                            setImageUrlData(customerDetail?.hospital_photo);
                          }}
                        >
                          VIEW
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xxl-4 col-6 ">
            <div className="mx-0 px-3">
              <div className="my-2">
                <div className="upload-image-label-container d-flex justify-content-between">
                  <label className="my-1 Neutral_Color fs_sm_14">
                    Photo of Clinic/Hospital’s Nameboard
                  </label>
                </div>

                <div
                  className="manufacturer-doc-upload-container"
                  style={{ position: "relative" }}
                >
                  <img
                    className="image-upload"
                    src={customerDetail?.hospital_nameboard_photo}
                  />
                  <div
                    className="w-100"
                    style={{
                      position: "absolute",
                      zIndex: "55",
                      top: "0",
                      maxWidth: "450px",
                    }}
                  >
                    <div
                      className="manufacturer-doc-upload-container"
                      style={{
                        backgroundColor: "rgb(38, 44, 61, 0.6 )",
                      }}
                    >
                      <div
                        className="align-items-center px-2 mx-2 my-2"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          backgroundColor: "#fff",
                          borderRadius: "5px",
                        }}
                      >
                        <span className="fs_11 Medium_Purple fw_500">
                          {customerDetail?.hospital_nameboard_photo_lat} ,
                          <span className="ms-1">
                            {customerDetail?.hospital_nameboard_photo_long}
                          </span>
                        </span>
                      </div>
                      <div
                        className="align-items-center"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          top: "43%",
                          left: "40%",
                        }}
                      >
                        <img src={eye} className="mb-2" />
                        <button
                          className="fs_16 fw_600"
                          style={{
                            backgroundColor: "transparent",
                            color: "#E7E5FF",
                            border: "none",
                          }}
                          onClick={() => {
                            setImageModal(true);
                            setImageTitleData(
                              "Photo of Clinic/Hospital’s Nameboard"
                            );
                            setImageUrlData(
                              customerDetail?.hospital_nameboard_photo
                            );
                          }}
                        >
                          VIEW
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {customerDetail?.doctorSelfPharmacy != null && (
            <>
              <div className="col-xxl-4 col-6 ">
                <div className="mx-4 px-3">
                  <div className="my-2">
                    <div className="upload-image-label-container d-flex justify-content-between">
                      <label className="my-1 Neutral_Color">Pharmacy</label>
                    </div>

                    <div
                      className="manufacturer-doc-upload-container"
                      style={{ position: "relative" }}
                    >
                      <img
                        className="image-upload"
                        src={customerDetail?.doctorSelfPharmacy?.pharmacy_photo}
                      />
                      <div
                        className="w-100"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          top: "0",
                          maxWidth: "450px",
                        }}
                      >
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{
                            backgroundColor: "rgb(38, 44, 61, 0.6 )",
                          }}
                        >
                          <div
                            className="align-items-center px-2 mx-2 my-2"
                            style={{
                              position: "absolute",
                              zIndex: "55",
                              backgroundColor: "#fff",
                              borderRadius: "5px",
                            }}
                          >
                            <span className="fs_11 Medium_Purple fw_500">
                              {
                                customerDetail?.doctorSelfPharmacy
                                  ?.pharmacy_photo_lat
                              }
                              ,
                              <span className="ms-1">
                                {
                                  customerDetail?.doctorSelfPharmacy
                                    ?.pharmacy_photo_long
                                }
                              </span>
                            </span>
                          </div>
                          <div
                            className="align-items-center"
                            style={{
                              position: "absolute",
                              zIndex: "55",
                              top: "43%",
                              left: "40%",
                            }}
                          >
                            <img src={eye} className="mb-2" />
                            <button
                              className="fs_16 fw_600"
                              style={{
                                backgroundColor: "transparent",
                                color: "#E7E5FF",
                                border: "none",
                              }}
                              onClick={() => {
                                setImageModal(true);
                                setImageTitleData("Pharmacy");
                                setImageUrlData(
                                  customerDetail?.doctorSelfPharmacy
                                    ?.pharmacy_photo
                                );
                              }}
                            >
                              VIEW
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-4 col-6 ">
                <div className="mx-4 px-3">
                  <div className="my-2">
                    <div className="upload-image-label-container d-flex justify-content-between">
                      <label className="my-1 Neutral_Color">
                        Photo of Pharmacy’s Nameboard
                      </label>
                    </div>

                    <div
                      className="manufacturer-doc-upload-container"
                      style={{ position: "relative" }}
                    >
                      <img
                        className="image-upload"
                        src={
                          customerDetail?.doctorSelfPharmacy
                            ?.pharmacy_nameboard_photo
                        }
                      />
                      <div
                        className="w-100"
                        style={{
                          position: "absolute",
                          zIndex: "55",
                          top: "0",
                          maxWidth: "450px",
                        }}
                      >
                        <div
                          className="manufacturer-doc-upload-container"
                          style={{
                            backgroundColor: "rgb(38, 44, 61, 0.6 )",
                          }}
                        >
                          <div
                            className="align-items-center px-2 mx-2 my-2"
                            style={{
                              position: "absolute",
                              zIndex: "55",
                              backgroundColor: "#fff",
                              borderRadius: "5px",
                            }}
                          >
                            <span className="fs_11 Medium_Purple fw_500">
                              {
                                customerDetail?.doctorSelfPharmacy
                                  ?.pharmacy_nameboard_lat
                              }
                              ,
                              <span className="ms-1">
                                {
                                  customerDetail?.doctorSelfPharmacy
                                    ?.pharmacy_nameboard_long
                                }
                              </span>
                            </span>
                          </div>
                          <div
                            className="align-items-center"
                            style={{
                              position: "absolute",
                              zIndex: "55",
                              top: "43%",
                              left: "40%",
                            }}
                          >
                            <img src={eye} className="mb-2" />
                            <button
                              className="fs_16 fw_600"
                              style={{
                                backgroundColor: "transparent",
                                color: "#E7E5FF",
                                border: "none",
                              }}
                              onClick={() => {
                                setImageModal(true);
                                setImageTitleData(
                                  "Photo of Pharmacy’s Nameboard"
                                );
                                setImageUrlData(
                                  customerDetail?.doctorSelfPharmacy
                                    ?.pharmacy_nameboard_photo
                                );
                              }}
                            >
                              VIEW
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* PHARMACY BASIC DETAILS */}
      {customerDetail?.doctorSubscribedVendors[0].onboarding_type ===
        "attach" &&
        customerDetail?.vendorDoctorPharmacy && (
          <>
            {customerDetail?.vendorDoctorPharmacy?.pharmacy?.is_details ==
              true && (
              <div className="mb-4">
                <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                  Pharmacy's Basic Details
                </div>
                <div className="product-details-container ms-2 ps-1">
                  <div className="pt-3 row ">
                    {PharmacyBasicDetails.map((item, index) => (
                      <div
                        key={index}
                        className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-1 me-4 px-2 customers-basic-heading-container"
                      >
                        <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                          {item.heading}
                        </h5>
                        <p className={`fs_15 fn_Nunito fw_500 color_262c3d`}>
                          {item.title}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {customerDetail?.vendorDoctorPharmacy?.pharmacy
              ?.is_contact_details === true && (
              <div className="mb-4">
                <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                  Pharmacy's Contact Details
                </div>
                <div className="product-details-container ms-2 ps-1">
                  <div className="pt-3 row row-cols-6">
                    {pharmacyContactDetails.map((item, index) => (
                      <div className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-2 mx-0 pe-3 customers-heading-container">
                        <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                          {item.heading}
                        </h5>
                        {item.heading === "Email Address" ? (
                          <p
                            className={`fs_15 fn_Nunito fw_500 color_262c3d -truncate col-lg-10 email-slice `}
                            title={item.title}
                          >
                            {item.title}
                          </p>
                        ) : item.heading ? (
                          <p className="fs_15 fn_Nunito fw_500 color_262c3d">
                            {item.title}
                          </p>
                        ) : (
                          <p className={`fs_15 fn_Nunito fw_500 color_262c3d `}>
                            {item.title}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </>
        )}

      <ImageViewModal
        show={imageModal}
        ShowClose={() => setImageModal(false)}
        imageTitleData={imageTitleData}
        imageUrlData={imageUrlData}
      />
      <PdfView
        show={openPdf}
        handleClose={() => setOpenPdf(false)}
        pdfUrl={pdfFileUrl}
        filename={filename}
      />
    </>
  );
};

export default DoctorView;
